import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetAudioCoverageStatsV1Response } from './get-audio-coverage-stats-v1-response';
import { getAudioCoverageStatsV1ResponseSchema } from './get-audio-coverage-stats-v1-response';

export async function getAudioCoverageStatsV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetAudioCoverageStatsV1Response>> {
  return getRequest<IGetAudioCoverageStatsV1Response>({
    path: '/sys/audio/v1/coverage-stats',
    schema: getAudioCoverageStatsV1ResponseSchema,
    options,
  });
}
